module.exports = __webpack_public_path__ + "ENG_SPT6-Chores_225002643-ef53f645966d460b54cb91168e59fabb.png";